'use client'

import dynamic from 'next/dynamic'

// The Google Maps SDK touches `window`, so the map stays client-only (ssr: false).
const PropertyMapLazy = dynamic(
  () => import('@/components/listings/PropertyMap').then((mod) => ({ default: mod.PropertyMap })),
  { ssr: false, loading: () => <div className="aspect-[2/1] w-full bg-muted animate-pulse" /> },
)

interface SidebarMapProps {
  lat: number
  lng: number
}

/** Property sidebar map — Figma `Map` 4022:88920, 448 × 224 inside the 448px
 *  sidebar column (2:1). */
export function SidebarMap({ lat, lng }: SidebarMapProps) {
  return (
    <PropertyMapLazy
      lat={lat}
      lng={lng}
      className="aspect-[2/1] w-full overflow-hidden relative z-0"
    />
  )
}
